export default __webpack_public_path__ + "static/media/Centenary_Logo.8a5143e9.png";